import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Multiselect } from "multiselect-react-dropdown";

import { fetchPropertySuites } from "../../../../../store/actions/suites";
import { selectSuites } from "../../../../../store/selectors/suites";
import { selectProperties } from "../../../../../store/selectors/properties";
import { getBuildingLevels as fetchBuildingLevels, getPropertyBuildings } from "../../../../../store/actions/buildings";
import { useBranding } from "../../../../../branding/BrandingContextProvider";
import {
  fetchProperties,
} from "../../../../../store/actions/properties";

export const PropertyFilters = ({ propertyFilters, setPropertyFilters }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const roleName = auth.user.roles[0].role.name;

  

  //selectors
  const properties = useSelector(selectProperties);
  const propertySuites = useSelector(selectSuites);
  const buildingsList = useSelector((state) => {
    return state.buildings ?? [];
  });
  const levelsList = useSelector((state) => {
    return state.levels ?? [];
  });

  //state
  const setProject = (val) => {
    setPropertyFilters({ ...propertyFilters, project: val });
  };

  const setSuite = (val) => {
    let list = [];
    for (var i = 0; i < val.length; i++) {
      list.push({
        Id: val[i].Id,
        name: val[i].name,
      });
    }
    setPropertyFilters({ ...propertyFilters, suite: list });
  };

  const setBuilding = (val) => {
    setPropertyFilters({ ...propertyFilters, building: val });
  };

  const setLevel = (val) => {
    setPropertyFilters({ ...propertyFilters, level: val });
  };

  const { project, suite, building, level } = propertyFilters;
  const { branding } = useBranding();

  //fetching
  const getBuildings = (id) => {
    dispatch(getPropertyBuildings(id));
  };
  const getBuildingsLevels = (id) => {
    dispatch(fetchBuildingLevels(id));
  };
  const getPropertySuites = (id) => {
    dispatch(fetchPropertySuites(id, auth.user.id, roleName));
  };

  useEffect(() => {
    if (!auth || !dispatch) return;
    const loginUserId = auth.user.id;
    dispatch(fetchProperties(loginUserId, roleName, false));
  }, [dispatch, auth, roleName]);

  useEffect(() => {
    if (!project) return;
    getBuildings(project);
    getPropertySuites(project);
  }, [project]);

  useEffect(() => {
    if (!building) return;
    getBuildingsLevels(building);
  }, [building]);

  return (
    <>
      <div className="filters-modal__label">Project</div>
      <select
        defaultValue=""
        onChange={(e) => {
          setProject(e.target.value);
        }}
        value={project}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select Project
        </option>
        {properties.map((item, i) => (
          <option value={item.propertyId}>{item.name}</option>
        ))}
      </select>

      <div className="filters-modal__label">{branding.text.suite}</div>
      <div className="multi">
        <Multiselect
          id="suites"
          singleSelect
          options={
            project
              ? propertySuites.map((item, i) => ({
                  Id: item.id,
                  name: item.number,
                }))
              : []
          }
          selectedValues={suite}
          displayValue="name"
          placeholder={`Select ${branding.text.suite}`}
          onSelect={setSuite}
          onRemove={setSuite}
          disable={project ? false : true}
        />
      </div>

      <div className="filters-modal__label" style={{ marginTop: 15 }}>
        Building
      </div>
      <select
        defaultValue=""
        onChange={(e) => {
          setBuilding(e.target.value);
        }}
        value={building}
        className="filters-modal-select"
        disabled={project ? false : true}
      >
        <option selected="true" disabled="disabled" value="">
          Select Building
        </option>
        {buildingsList.map((item, i) => (
          <option value={item.id}>{item.building}</option>
        ))}
      </select>

      <div className="filters-modal__label">Level</div>
      <select
        defaultValue=""
        onChange={(e) => setLevel(e.target.value)}
        value={level}
        className="filters-modal-select"
        disabled={building ? false : true}
      >
        <option selected="true" disabled="disabled" value="">
          Select Level
        </option>
        {levelsList.map((item, i) => (
          <option value={item.id}>{item.level}</option>
        ))}
      </select>
    </>
  );
};
